export default "__VITE_ASSET__1467c6aa__"